export var ELocalizationLanguage;
(function (ELocalizationLanguage) {
    ELocalizationLanguage["SL"] = "sl";
    ELocalizationLanguage["EN"] = "en";
})(ELocalizationLanguage || (ELocalizationLanguage = {}));
/**
 * Gets the localized string for the given language, falls back to Slovene if translation is missing
 */
export function getLocalizedString(localizedString, language) {
    return localizedString[language] || localizedString.sl;
}
